import { useCallback, useEffect, useState } from "react";
import { getFleetVehiclesAPI } from "services/api/fleet/vehicles/api";
import { initialPagination } from "ui/components/Table/consts";
import VehicleEditCard from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/VehicleEditCard";
import VehicleImportModal from "ui/modules/fleet/vehicles/pages/VehicleSearchPage/components/VehicleImportModal/VehicleImportModal";
import FleetUnavailable from "./FleetUnavailable/FleetUnavailable";

/**
 * Globalna zaštita: dok tenant nema nijedno vozilo, na SVAKOM ekranu prikazuje
 * blokirajući overlay koji nudi unos prvog vozila ili uvoz iz datoteke.
 */
const FleetGuard: React.FC = () => {
  const [hasVehicles, setHasVehicles] = useState<boolean | null>(null);
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [showImportModal, setShowImportModal] = useState<boolean>(false);

  const refetchVehicleCount = useCallback(async () => {
    try {
      const result = await getFleetVehiclesAPI({ ...initialPagination, pageSize: 1 });
      setHasVehicles((result.pagination.totalCount ?? 0) > 0);
    } catch {
      // U slučaju greške ne blokiramo korisnika lažno
      setHasVehicles(true);
    }
  }, []);

  useEffect(() => {
    refetchVehicleCount();
  }, [refetchVehicleCount]);

  const handleAddSuccess = useCallback(() => {
    setShowAddModal(false);
    refetchVehicleCount();
  }, [refetchVehicleCount]);

  return (
    <>
      <FleetUnavailable
        show={hasVehicles === false}
        onAddVehicle={() => setShowAddModal(true)}
        onImport={() => setShowImportModal(true)}
      />

      <VehicleEditCard
        vehicleId={null}
        show={showAddModal}
        onSuccess={handleAddSuccess}
        onClose={() => setShowAddModal(false)}
      />

      <VehicleImportModal
        show={showImportModal}
        onClose={() => setShowImportModal(false)}
        onImportSuccess={refetchVehicleCount}
      />
    </>
  );
};

export default FleetGuard;
